<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block" style="margin: 20px;">
        <div class="document-block mt-2">
            <!-- Name And Contact -->
            <div class="formSection" style="text-align: center !important; border: dashed;">
                <div class="head">
                    <strong>Market Outstanding Report (Sales Associates Wise)</strong>
                </div>
                <table>
                    <tr>
                        <th rowspan="2">Sr. No.</th>
                        <th rowspan="2">Associate Name</th>
                        <th *ngFor="let ageing of ageingBuckets">
                            {{ ageing }}
                        </th>
                    </tr>
                    <tr>
                        <ng-container *ngFor="let ageing of ageingBuckets">
                            <!-- <th>Ageing Range</th> -->
                            <th>Amount Due</th>
                        </ng-container>
                    </tr>
                    <tr *ngFor="let catSale of agentOutstandingData; let i=index;">
                        <td><strong>{{i+1}}</strong></td>
                        <td><strong>{{catSale?.agentName}}</strong></td>
                        <ng-container *ngFor="let ageing of ageingBuckets">
                            <!-- <td>{{catSale[ageing]?.ageingDateRange}}</td> -->
                            <td class="numeric" [ngClass]="ageing == 'Over Due'? 'outstanding':''">
                                {{catSale[ageing]?.amountOutstanding}}
                            </td>
                        </ng-container>
                    </tr>
                    <tr>
                        <th colspan="2">Total</th>
                        <ng-container *ngFor="let ageing of ageingBuckets">
                            <th class="numeric" [ngClass]="ageing == 'Over Due'? 'outstanding':''">{{
                                ageingBucketsTotals[ageing]?.TotalAmountDue}}</th>
                        </ng-container>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</div>